// Fills the asset detail modal on the account library browse page from the
// clicked card's data-asset JSON (Bootstrap passes the trigger as relatedTarget).

$(document).on("show.bs.modal", "#assetDetailModal", function (event) {
  if (!event.relatedTarget || !event.relatedTarget.dataset.asset) return

  var asset = JSON.parse(event.relatedTarget.dataset.asset)
  var $modal = $(this)

  $modal.find(".js-asset-detail-name").text(asset.name)
  $modal.find(".js-asset-detail-type").text(asset.type || "—")
  $modal.find(".js-asset-detail-catalog").text(asset.catalog || "—")
  $modal
    .find(".js-asset-detail-tags")
    .text(asset.tags && asset.tags.length ? asset.tags.join(", ") : "—")
  $modal.find(".js-asset-detail-author").text(asset.author || "—")
  $modal.find(".js-asset-detail-license").text(asset.license || "—")
  $modal.find(".js-asset-detail-copyright").text(asset.copyright || "—")
  $modal
    .find(".js-asset-detail-blender-versions")
    .text(asset.blender_versions || "—")
  $modal.find(".js-asset-detail-size").text(asset.size || "—")
  $modal.find(".js-asset-detail-download").attr("href", asset.download_url)

  var $description = $modal.find(".js-asset-detail-description")
  $description.text(asset.description || "").toggle(!!asset.description)

  var $thumbWrap = $modal.find(".js-asset-detail-thumb-wrap")
  var $thumb = $thumbWrap.find(".js-asset-detail-thumb")
  var $placeholder = $thumbWrap.find(".js-asset-detail-thumb-placeholder")
  // toggleClass, not .toggle(): the placeholder carries d-inline-flex, whose
  // !important would beat any inline display style .toggle() sets.
  $thumb.toggle(!!asset.thumbnail_url)
  $placeholder.toggleClass("d-none", !!asset.thumbnail_url)
  if (asset.thumbnail_url) {
    $thumb.attr("src", asset.thumbnail_url).attr("alt", asset.name)
  } else {
    $placeholder
      .find(".js-asset-detail-thumb-placeholder-icon")
      .attr(
        "class",
        "fas fa-" +
          (asset.type_icon || "cube") +
          " js-asset-detail-thumb-placeholder-icon"
      )
  }
})

// Grid/list view toggle: both layouts render server-side, so switching is
// instant — no round-trip. Persisted the same way as the marketplace
// grid-density toggle (sort/product_grid.js). The browse page toggles two
// sibling layouts; the library management pages instead restyle their live
// table as cards (.js-asset-cardify — see asset_browse.scss) so the row
// upserts from scan polling keep landing in the one true markup. The toggle
// partial's data attributes carry each page's storage key and default view.
$(document).on("turbolinks:load", function () {
  var $toggle = $(".asset-browse-view-toggle")
  var $toggleButtons = $(".js-asset-view-toggle")
  if (!$toggleButtons.length) return

  var storageKey = $toggle.data("storage-key") || "assetBrowseView"

  function applyView(view) {
    $(".js-asset-view-grid").toggleClass("d-none", view !== "grid")
    $(".js-asset-view-list").toggleClass("d-none", view !== "list")
    $(".js-asset-cardify").toggleClass("asset-manage-grid", view === "grid")
    $toggleButtons.each(function () {
      var isActive = $(this).data("view") === view
      $(this)
        .toggleClass("active", isActive)
        .attr("aria-pressed", String(isActive))
    })
  }

  applyView(
    localStorage.getItem(storageKey) || $toggle.data("default-view") || "grid"
  )

  $toggleButtons.on("click", function () {
    var view = $(this).data("view")
    localStorage.setItem(storageKey, view)
    applyView(view)
  })
})
